import * as React from "react";
import { JSX } from "react/jsx-runtime";
const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={13} cy={13} r={13} fill="#4682B4" />
    <path
      d="M18.3431 13.4952C17.9137 13.4291 17.5323 13.727 17.4707 14.1517C17.316 15.2183 16.8296 16.1915 16.0638 16.9665C14.1148 18.9387 10.9459 18.9372 8.99764 16.9665C7.04979 14.995 7.04979 11.7871 8.99764 9.81601C9.73036 9.07494 10.6554 8.59175 11.6906 8.41586C12.1358 8.33036 12.6144 8.31558 13.1111 8.37252C13.793 8.45195 14.4277 8.6809 15.0069 9.01706L14.006 9.18999C13.5879 9.26258 13.3063 9.66447 13.3784 10.088C13.4422 10.4671 13.7673 10.7348 14.1351 10.7348C14.178 10.7348 14.2215 10.7314 14.2658 10.7238L16.949 10.2596C17.1494 10.2247 17.3288 10.1107 17.4467 9.94204C17.5646 9.77377 17.6112 9.56481 17.5766 9.36122L17.1171 6.64641C17.0465 6.22328 16.6546 5.93987 16.2297 6.0109C15.8115 6.08348 15.5299 6.48576 15.6021 6.90928L15.723 7.62383C14.9789 7.2014 14.1581 6.9281 13.286 6.8265C12.6328 6.75128 11.9992 6.7722 11.4192 6.88462C10.084 7.111 8.87079 7.74425 7.91051 8.71591C5.36316 11.2936 5.36316 15.488 7.91051 18.0665C9.18414 19.3557 10.8576 20 12.5307 20C14.2042 20 15.8768 19.3558 17.1509 18.0665C18.1517 17.0537 18.7883 15.7782 18.9918 14.3781C19.0534 13.9526 18.7628 13.5575 18.3431 13.4952Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
